import React, { FC, useMemo } from 'react';
import { useParams } from 'react-router';

import { Button } from 'devextreme-react/button';

import { AppLayoutTop } from 'components/appComponents';
import { LoadIndicator } from 'devextreme-react';

type HeaderLayoutProps = {
  isCanEditArch: boolean;
  taskIsArch: boolean;
  onSubmit: (e: any) => void;
  isLoading: boolean;
};

const HeaderLayout: FC<HeaderLayoutProps> = ({ isCanEditArch, onSubmit, taskIsArch, isLoading }) => {
  let { id } = useParams<{ id: string }>();

  const canShowButton = useMemo(() => {
    if (taskIsArch && isCanEditArch) {
      return true;
    }

    if (taskIsArch && !isCanEditArch) {
      return false;
    }

    if (!taskIsArch) {
      return true;
    }

    return true;
  }, [isCanEditArch, taskIsArch]);

  return (
    <AppLayoutTop title={'Заявка ' + (id ? id : '')}>
      {canShowButton && (
        <Button text="Сохранить" type="default" useSubmitBehavior={false} disabled={isLoading} onClick={onSubmit}>
          <span className="dx-button-text">
            {isLoading ? <LoadIndicator width={'24px'} height={'24px'} visible={true} /> : 'Сохранить'}
          </span>
        </Button>
      )}
    </AppLayoutTop>
  );
};

export default HeaderLayout;
